import { Badge } from '@design-system';
import { ShieldCheck } from 'lucide-react';
import { SheetModal } from '@/components/SheetModal';
import { ROISlideOutContent } from '@/components/LearnMoreSlideOutContent';

import { useState } from 'react';

import { formatCurrency } from '@shared/formatCurrency';

import { FundingPolicyType } from '@shared';

interface QuoteROIDisplayProps {
  projectedCostCoverage?: number;
  policyType?: number;
  displayROI?: string;
  className?: string;
}

export function QuoteROIDisplay({
  projectedCostCoverage,
  policyType,
  displayROI,
  className = '',
}: QuoteROIDisplayProps) {
  const [isROIGuidanceOpen, setIsROIGuidanceOpen] = useState(false);

  if (projectedCostCoverage === undefined) {
    return null;
  }

  const totalValue = projectedCostCoverage;
  const isCareAssurance = policyType === FundingPolicyType.careScoutCareAssurance;

  return (
    <div className={`flex flex-col gap-1 ${className}`}>
      <div className="text-muted-foreground text-xs font-medium">Projected Coverage</div>
      <button
        type="button"
        onClick={event => {
          event.stopPropagation();
          setIsROIGuidanceOpen(true);
        }}
        className="flex items-center gap-1 text-sm font-semibold text-green-600 underline decoration-dotted decoration-1 underline-offset-2 transition-colors hover:text-green-700 sm:text-base"
      >
        <ShieldCheck
          className="size-4.5"
          strokeWidth={2.5}
        />
        {formatCurrency(totalValue)}
      </button>
      {displayROI && (
        <Badge variant="success">
          ROI {displayROI}
          {isCareAssurance && <sup>*</sup>}
        </Badge>
      )}

      <SheetModal
        open={isROIGuidanceOpen}
        onClose={() => setIsROIGuidanceOpen(false)}
        title="Waterlily AI"
        subTitle=""
        modal={true}
        className="md:min-w-150 lg:min-w-162.5 min-w-[95%] sm:min-w-[90%]"
      >
        <div className="flex min-h-full flex-1 flex-col overflow-auto text-black">
          <div className="flex flex-1 flex-col py-4">
            <ROISlideOutContent policyType={policyType} />
          </div>
        </div>
      </SheetModal>
    </div>
  );
}
